// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".rename-watch-data[data-v-e45d4a48]{margin:2rem}.rename-watch-data .p-inputtext[data-v-e45d4a48]{width:100%;margin:.5rem 0}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
